import React, { memo } from 'react'
import { Path, Circle as _Circle, Rect } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 75 74"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Rect x={0.998} width={74.002} height={74} rx={37} fill="#425893" />
      <Path
        d="M29.96 38.108h3.727v15.344c0 .303.246.548.549.548h6.319a.548.548 0 0 0 .548-.548V38.18h4.285c.278 0 .513-.21.545-.486l.65-5.649a.548.548 0 0 0-.544-.61h-4.935v-3.542c0-1.067.574-1.608 1.708-1.608h3.227a.548.548 0 0 0 .548-.549v-5.185a.548.548 0 0 0-.548-.548h-4.447a4.247 4.247 0 0 0-.204-.004c-.771 0-3.453.151-5.572 2.1-2.347 2.16-2.021 4.746-1.943 5.194v4.141h-3.912a.548.548 0 0 0-.549.549v5.576c0 .303.246.548.549.548Z"
        fill="#fff"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconFacebookCircle'

export const IconFacebookCircle = memo(themed(Icon))
